export const okButton = "lfb";
export default {okButton};